export interface AnalyticsEvent {
  eventName: string;
  eventData: string;
}
